export const INSTRUCTION_TRACKS = [
  {
    id: "hr",
    label: "Запуск для HR",
    summary: "Как за 15 минут запустить обучение для команды без технической поддержки.",
    steps: [
      {
        step: 1,
        title: "Оформите подписку",
        description:
          "Выберите тариф по размеру команды. Пока подписка не активна, сотрудники не смогут пройти программу по ссылке.",
        bullets: [
          "Откройте раздел «Тарифы» в профиле или на дашборде.",
          "После оплаты статус подписки отобразится в профиле.",
        ],
        link: { href: "/main/price", label: "Перейти к тарифам" },
      },
      {
        step: 2,
        title: "Подготовьте проект",
        description:
          "Создайте сценарий, тренажёр, базу знаний или курс — в зависимости от задачи обучения.",
        bullets: [
          "На дашборде нажмите «Создать» и выберите тип проекта.",
          "Заполните контент: видео в сценах, вопросы в тренажёре, пары «вопрос — ответ» в базе знаний.",
          "Настройте стартовый пост — это первое сообщение, которое увидит сотрудник в боте.",
        ],
      },
      {
        step: 3,
        title: "Проверьте превью",
        description:
          "Справа в редакторе есть панель «Превью» — она показывает, как программа выглядит в Telegram.",
        bullets: [
          "Откройте проект и нажмите «Запустить» в правой панели.",
          "Убедитесь, что стартовый пост и первый шаг отображаются корректно.",
          "Если видео не загружается в превью, проверьте прохождение в реальном боте по ссылке.",
        ],
      },
      {
        step: 4,
        title: "Опубликуйте и включите мессенджеры",
        description:
          "Пока проект «В работе», ссылка для команды недоступна.",
        bullets: [
          "В настройках проекта выберите статус «Опубликован» и нажмите «Сохранить».",
          "В блоке «Доступ для команды» включите Telegram и/или MAX.",
          "Чеклист «Готов к запуску» в настройках подскажет, что ещё не сделано.",
        ],
      },
      {
        step: 5,
        title: "Разошлите ссылку сотрудникам",
        description:
          "Скопируйте ссылку из настроек и отправьте её в корпоративный чат, по email или в LMS.",
        bullets: [
          "Один сотрудник = одно место по тарифу.",
          "Новые люди смогут войти, пока не исчерпан лимит команды.",
          "Приложите инструкцию для сотрудников — что нажать после перехода по ссылке.",
        ],
        link: { href: "/dlya-sotrudnika", label: "Инструкция для сотрудников", external: false },
      },
    ],
  },
  {
    id: "author",
    label: "Создание контента",
    summary: "Как автору собрать программу: сценарий, тренажёр, база знаний или курс.",
    steps: [
      {
        step: 1,
        title: "Создайте проект",
        description: "На дашборде выберите тип контента под вашу задачу.",
        bullets: [
          "Сценарий — видео и ветвления, подходит для пошагового обучения.",
          "Тренажёр — вопросы с вариантами ответов, проверка знаний.",
          "База знаний — быстрые ответы на типовые вопросы на смене.",
          "Курс — последовательность уроков с материалами.",
        ],
      },
      {
        step: 2,
        title: "Наполните программу",
        description: "Минимум контента, без которого бот не запустится:",
        bullets: [
          "Сценарий: загрузите видео хотя бы в одну сцену и свяжите сцены кнопками.",
          "Тренажёр: добавьте хотя бы один вопрос с текстом.",
          "База знаний: добавьте пары «вопрос — ответ».",
          "Курс: добавьте хотя бы один урок с названием.",
        ],
      },
      {
        step: 3,
        title: "Настройте стартовый пост",
        description:
          "В настройках проекта заполните название, программу и текст приветствия. По желанию загрузите обложку.",
        bullets: [
          "Это первое сообщение сотрудника в боте — напишите, зачем проходить программу.",
          "Кнопка «Пример стартового поста» покажет, как это выглядит в превью.",
        ],
      },
      {
        step: 4,
        title: "Проверьте в превью",
        description:
          "Правая панель имитирует Telegram. Нажмите «Запустить», чтобы увидеть стартовый пост и первый шаг.",
        bullets: [
          "Подсказки в панели объяснят, если не хватает видео или вопросов.",
          "Для сценария нажимайте кнопки в превью, чтобы перейти к следующим сценам.",
        ],
      },
      {
        step: 5,
        title: "Опубликуйте для команды",
        description:
          "Когда контент готов, переведите проект в статус «Опубликован» и передайте ссылку HR.",
        bullets: [
          "Чеклист «Готов к запуску» в настройках покажет прогресс.",
          "HR-коллеге можно отправить страницу «Инструкция для сотрудников».",
        ],
        link: { href: "/dlya-sotrudnika", label: "Инструкция для сотрудников", external: false },
      },
    ],
  },
];
